exports = module.exports = require("../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-4c12a352]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.2@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c12a352","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.0.3@sass-loader/lib/loader.js!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 14
// module chunks = 0